module.exports = __webpack_public_path__ + "static/media/Postales-07.178e3d65.png";